import { render, staticRenderFns } from "./SessionMessages.vue?vue&type=template&id=25f0aeec"
import script from "./SessionMessages.vue?vue&type=script&lang=js"
export * from "./SessionMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports